<template>
  <div class="content-page mobile-app" v-loading.fullscreen.lock="mainLoding">
    <div class="main-page">
      <div class="title-page">案件详情</div>
      <div class="main-contentBox">

        <div class="my-step-box pc-step">
          <div class="common step-1 success" :style="`border-color:${statusInfo.color};color:${statusInfo.color}`">
            <div class="bar"></div>
            {{ statusInfo.text }}
          </div>
          <div :class="modifyStatus == '0'?'common step-2':modifyStatus == '1'?'common step-3 active':'common step-3 success'">
            <div class="bar"></div>
            {{modifyStatus == '2'?'补正完成': '补正中'}}
          </div>
          <div :class="hasSlsc != '1'?'common step-3':status == '3'?'common step-3 active':'common step-3 success'">
            <div class="bar"></div>
            已受理，审查中
          </div>
          <div :class="status == '4'?'common step-4 success':'common step-4'">
            {{status != '4'?'已办结': caseStatusText}}
          </div>
        </div>
        <!--    状态    -->
        <div class="my-step-box mobile-step">
          <div class="common step-1 success" :style="`border-color:${statusInfo.color};color:${statusInfo.color}`">
            <div class="bar"></div>
             {{ statusInfo.text }}
          </div>
          <div :class="modifyStatus == '0'?'common step-2':modifyStatus == '1'?'common step-3 active':'common step-3 success'">
            <div class="bar"></div>
            {{modifyStatus == '2'?'补正完成': '补正中'}}
          </div>
          <div :class="hasSlsc != '1'?'common step-3':status == '3'?'common step-3 active':'common step-3 success'">
            <div class="bar"></div>
            已受理，审查中
          </div>
          <div :class="status == '4'?'common step-4 success':'common step-4'">
            {{status != '4'?'已办结': caseStatusText}}
          </div>
        </div>
        <div>
          <div class="search-items search title-no number">
            <div class="title-no-left">
              <div class="search-item">
                <div class="search-label">
                  申请编号：
                </div>
                <div>{{ inquireNo  }}</div>
              </div>
              <div class="search-item">
                <div class="search-label">
                  案号：
                </div>
                <div>{{ caseInfo.caseNo || '-'  }}</div>
              </div>
              <div class="search-item" v-if="modifyStatus != 0 && caseInfo.tcEndTime && (caseInfo.caseSource !=3 || caseInfo.caseSource !=4)">
                <div class="search-label">
                  到达时间：
                </div>
                <div>{{caseInfo.tcEndTime}}</div>
              </div>
              <div class="search-item" v-if="modifyStatus == 0 && caseInfo.createTime  && (caseInfo.caseSource !=3 || caseInfo.caseSource !=4)">
                <div class="search-label">
                  到达时间：
                </div>
                <div>{{caseInfo.createTime}}</div>
              </div>
<!--              <div class="search-item" v-if="!caseInfo.tcEndTime && (caseInfo.caseSource !=3 || caseInfo.caseSource !=4)">-->
<!--                <div class="search-label">-->
<!--                  提交时间：-->
<!--                </div>-->
<!--                <div>{{caseInfo.createTime}}</div>-->
<!--              </div>-->
              <div v-if="caseInfo.withdrawTime" class="search-item">
                <div class="search-label">
                  申请撤回时间：
                </div>
                <div>{{ caseInfo.withdrawTime  }}</div>
              </div>
              <div class="search-item" v-if="caseInfo.giveBackReason">
                <div class="search-label">
                  退回原因：
                </div>
                <div>{{ caseInfo.giveBackReason  }}</div>
              </div>
            </div>
          </div>
        </div>
        <van-notice-bar color="green" background="#ecf9ff" left-icon="info-o" style="margin-bottom: 10px">
        复议申请内容以申请人提交的复议申请书为准，以上内容为对复议申请的摘录，仅供参考。如有疑问，请致电{{ orgPhone }}。
      </van-notice-bar>
        <div class="star-title">
          <span class="star"></span>申请人信息（摘要）
        </div>
        <!-- 申请人 -->
        <div class="form-common">
          <div v-for="(item, index) in applicantInfo" :key="index" class="appinfo-box">
            <div class="typeTitle">
              <div class="typeTitle-name"> {{ item.applicantCategory == '1' ? '个人' : '法人' }} </div>
            </div>
            <div class="search-items applicat-search-items">
              <van-field :label="item.applicantCategory == '1' ? '姓名：' : '单位名称：'" :value="item.applicantName" readonly />
              <van-field v-show="item.applicantCategory == '1'" label="性别：" :value="item.gender == 0 ? '女' : item.gender == 1 ? '男' : '未知'" readonly />
              <van-field v-show="item.applicantCategory == '2'" label="社会信用代码" :value="item.socialUnifiedCreditCode" readonly />
              <van-field v-show="item.applicantCategory == '2'" label="法人代表：" :value="item.legalRepresentative" readonly />
              <van-field v-show="item.applicantCategory == '2'" label-width="100" label="营业执照或其他证件材料 (图片)" :value="item.fileListJpg && item.fileListJpg.length > 0 ? item.fileListJpg[0].name : ''" readonly >
                <div slot="extra" style="margin-left: auto" v-if="item.fileListJpg && item.fileListJpg.length > 0">
                <span @click="handlePreview(item.fileListJpg[0])"> 预览 </span>
                </div>
              </van-field>
              <van-field v-show="item.applicantCategory == '1'" label="国家：" :value="item.countryName" readonly />
              <van-field v-show="item.applicantCategory == '1'" label="证件类型：" :value="item.identificationTypeName" readonly />
              <van-field v-show="item.applicantCategory == '2'" label="联系人：" :value="item.contactName" readonly />
              <van-field v-show="item.applicantCategory == '2'" label="联系人手机号码：" :value="item.phone" readonly />
              <van-field label="联系人证件号码：" :value="item.identificationCard" readonly />
              <van-field label-width="100" label="身份证人像面" :value="item.fileListJpg2 && item.fileListJpg2.length > 0 ? item.fileListJpg2[0].name : ''" readonly >
                <div slot="extra" style="margin-left: auto" v-if="item.fileListJpg2 && item.fileListJpg2.length > 0">
                <span @click="handlePreview(item.fileListJpg2[0])"> 预览 </span>
                </div>
              </van-field>
              <van-field label-width="100" label="身份证国徽面" :value="item.fileListJpg && item.fileListJpg.length > 0 ? item.fileListJpg[0].name : ''" readonly >
                <div slot="extra" style="margin-left: auto" v-if="item.fileListJpg && item.fileListJpg.length > 0">
                <span @click="handlePreview(item.fileListJpg[0])"> 预览 </span>
                </div>
              </van-field>
              <van-field v-show="item.applicantCategory == '1'" label="出生日期：" :value="$moment(item.birthday).format('YYYY年MM月DD日')" readonly />
             <van-field v-show="item.applicantCategory == '1'" label="手机号码：" :value="item.phone" readonly />

            <van-field label-width="100" label="文书送达地址：" class="addr" type="textarea" readonly>
              <div slot="input" style="min-height: 0">
                {{ item.deliveryArea }}{{ item.addr }}

              </div>
            </van-field>
            </div>
          </div>
        </div>
        <!-- 被申请人信息 -->
        <div class="star-title">
          <span class="star"></span>被申请人信息（摘要）
        </div>
        <div class="appinfo-box">
          <van-field label="被申请人信息：" label-width="100" readonly>
            <div v-for="(item, index) in respondentInfo" :key="index" slot="input">
                <span>{{ item.respondentName }} </span>
                <span v-show="index !== respondentInfo.length - 1">、</span>
              </div>
          </van-field>
          <van-field label="复议机关：" label-width="100" :value="applyInfo.reconsiderationAgencyName" readonly />

        </div>
        <!-- 行政复议请求 -->
        <div class="star-title">
          <span class="star"></span>行政复议请求（摘要）
        </div>
        <div class="appinfo-box">
          <van-field label="请求类型：" label-width="80" :value="applyInfo.actCategory === '1' ? '不服行政不作为' : '不服具体行政行为'" readonly />
          <van-field label="行政行为文书名称：" v-show="applyInfo.actCategory === '2'" label-width="100" :value="applyInfo.actName" readonly />
          <van-field label="行政行为文号：" v-show="applyInfo.actCategory === '2'" label-width="100" :value="applyInfo.actDocumentNo" readonly />
          <van-field label="行政行为做出时间：" v-show="applyInfo.actCategory === '2'" label-width="100" :value="applyInfo.actDecisionDate" readonly />
          <van-field label="请求内容：" type="textarea" label-width="80" :value="applyInfo.applyType" readonly />
        </div>
        <!-- 事实和理由 -->
        <div class="star-title reason">
          <span class="star"></span>事实和理由（摘要）
        </div>
        <div class="appinfo-box">
          <van-field label="事实和理由：" type="textarea" label-width="100c" :value="applyInfo.factsAndReasons" readonly />
        </div>
        <!-- 证据材料 -->
        <div class="star-title">
          <span class="star"></span>证据材料
        </div>
        <div class="appinfo-box">
          <van-field label="提交相关具体材料：" label-width="140" readonly>
            <div slot="input">
              <div v-for="(item, index) in specFileList" :key="index" class="fileList-item">
                  <span class="zhengju">{{ item.originName || item.evidenceName }}</span>

                  <div style="display:flex;align-items:center;justify-content: flex-end;">
                    <div v-if="item.evidenceType == 'jpg' || item.evidenceType == 'png' || item.evidenceType == 'jpeg'" @click="handlePreview(item)">预览</div>
                    <!-- <div @click="downLoad(item,'zjcl')" style="margin-left:12px">
                      下载
                    </div> -->
                  </div>
              </div>
            </div>
          </van-field>
        </div>
        <div class="search-items search ">
          <!-- 补正理由 -->
          <div class="star-title" v-if="inquireInfo.correctionReason">
            <span class="star" />相关补正说明（摘要）
          </div>
          <van-field v-if="inquireInfo.correctionReason" label="相关补正说明" label-width="100" :value="inquireInfo.correctionReason" readonly />
        </div>
        <div class="star-title">
          <span class="star"></span>历史申请文书
        </div>
        <div class="fileList cailiao" v-if="historyList.length > 0">
          <van-field v-for="(item, index) in historyList" :key="index" :label="item.evidenceName" :value="inquireInfo.correctionReason" readonly >
            <div slot="extra">
              <!-- <div @click="downLoad(item)">
                下载
              </div> -->

            </div>
          </van-field>
        </div>
        <van-field v-else label="暂无历史文书" label-width="100" readonly />
        <div class="btnLists">
          <div class="border-btn" :class="{'w100' : (oprate == 'search' || oprate == 'apply') && indexofStr(caseInfo.caseTips,'ajibzz') < 0}" @click="back">返回上一页</div>
          <div v-if="oprate == 'revokeApply' && isRevoke == 1" class="primary-btn" @click="revoke()">撤回</div>
<!--          <div v-if="indexofStr(caseInfo.caseTips,'ajibzz') > -1 && oprate == 'search'" class="primary-btn" @click="corrent()">复议申请补正</div>-->

        </div>
      </div>
    </div>
    <dialogPreview :applicantInfo="applicantInfo" ref="dialogPreview" />
    <revokeTip :caseOrderNo="caseOrderNo" :applicantInfo="applicantInfo" ref="revokeTip"
      @openCh="openCh" />
    <!--   撤回书预览   -->
    <van-popup v-model="fileReviewDialog" position="bottom" :style="{ height: '80vh' }" round>
      <span class="btnLists" style="z-index: 999;background: #fff;text-align: right;display: flex;">
        <div class="border-btn" @click="closePreview">取消</div>
          <div class="primary-btn" @click="doSubmit">下一步</div>
        </span>
      <div style="max-height: 80%; overflow-y: auto" v-loading="loading">
        <img v-for="(item,index) in imgList" :key="index" :src="item.fileBaseUri" />
      </div>
    </van-popup>
    <!-- 签名组件 -->
    <mobileSignDialog ref="mobileSignDialog" signType="revoke" :opera="1" :detailInfo="detailInfo" @signature-submit="signatureSubmit" />
  </div>
</template>

<script>
import Api from '@api/api'
import dialogPreview from '@/components/dialogPreview/dialogPreview'
import revokeTip from './components/revokeTip'
import mobileSignDialog from '@/components/mobileSignDialog/mobileSignDialog'
import { ImagePreview, Dialog } from 'vant';
const moduleCodeSwitch = () => {
  switch (localStorage.getItem('oprate')) {
    case 'apply':
      return '1';
      break;
    case 'search':
      return '2';
      break;
    case 'revokeApply':
      return '3';
      break;
  }
}
export default {
  components: {
    dialogPreview,
    revokeTip,
    mobileSignDialog
  },
  watch: {
    writList: function(newVal){
      if (newVal) {
        newVal.map(item => {
          item.fileBaseUri = "data:image/png;base64," + item.fileBaseUri
        })
        this.imgList = newVal
        this.loading = false
      }
    },
  },
  computed: {
    statusInfo () {
      switch (this.caseInfo.caseStatus) {
        case '15': case 15:
          return {
            text: '已确认撤回',
            color: 'green'
          }
          break;
        case '9': case 9:
          return {
            text: '已退回',
            color: '#afa3a3'
          }
          break;
        case '12': case 12:
          return {
            text: '合并至已收案件',
            color: 'green'
          }
          break;
        default:
          return {
            text: '已提交',
            color: 'green'
          }
          break;
      }
      return this.$store.state.options.optionReconsiderItem
    }
  },
  data () {
    return {
      mainLoding: false,
      loading: false,
      isSign: false, // 是否已签名
      searchType: this.$route.query.searchType || '0',
      oprate: localStorage.getItem('oprate') || '',
      isRevoke: this.$route.query.isRevoke || '',
      from: this.$route.query.from || '',
      imgList:[],
      detailInfo: {},
      applicantInfo: [
        {
          id: '',
          applicantCategory: '2',
          applicantName: '',
          gender: '',
          country: '',
          identificationType: '',
          identificationCard: '',
          identificationFile: '',
          bornDate: '',
          phone: '',
          telephone: '',
          addr: '',
          postcode: '',
          deliveryAddr: '',
          deliveryPostcode: '',
          sort: 1
        }
      ],
      respondentInfo: {},
      inquireInfo: {
        applyTime: ''
      },
      inquireNo: '',
      hasSlsc: '',
      applyInfo: {},
      number: '',
      password: '', // 新建页面带过来 存在cookie中
      rePassword: '', // 接口返回 查询页直接进入
      countGR: 0,
      countFR: 0,
      status: 0,
      modifyStatus: 0, //补正中状态 0-没有补正 1-正在补正中 2-补正中完成: 0,
      caseStatusText: '', // 案件状态（0未接收 2补正中 4已处理 5已撤回 9已退回）
      fileList1: [],
      fileList2: [],
      caseOrderNo: '',
      caseInfo: {},
      fileReviewDialog:false,
      writList:[],
      specFileList:[],
      historyList:[]
    }
  },
  mounted () {
    this.detail()
  },
  destroyed () {
    // 页面销毁密码
    // this.$cookie.remove('LoginPass') //补正跳转需要查看详情
  },
  methods: {
    back() {
      if (this.from == 'list') {
        let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'))
        this.$router.replace({
          name: 'Mcaselist',
          query: {
            phone: applicantInfo ? applicantInfo.phone : '',
            loginName: applicantInfo ? applicantInfo.loginName : '',
            identificationCard: applicantInfo ? applicantInfo.identificationCard : '',
            applicantCategory: applicantInfo ? applicantInfo.applicantCategory : ''
          }
        })
      } else {
        // this.$router.push('/m-searchLogin')
        let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'))
        if(this.status == 1){
           this.$router.push('/m-register')
        } else {
          this.$router.replace({
            name: 'Mcaselist',
            query: {
              phone: applicantInfo ? applicantInfo.phone : '',
              loginName: applicantInfo ? applicantInfo.loginName : '',
              identificationCard: applicantInfo ? applicantInfo.identificationCard : '',
              applicantCategory: applicantInfo ? applicantInfo.applicantCategory : ''
            }
          })
        }
      }
    },
    indexofStr(str1, str2){
      return str1 ? str1.indexOf(str2) : -1
    },
    // 关闭预览
    closePreview() {
      this.fileReviewDialog = false;
      this.isSign = false; // 重置签名状态
    },
    // 撤回 - 显示确认弹窗
    doSubmit(){
      Dialog.confirm({
        title: '提示',
        message: '是否确认撤回申请书无误',
        confirmButtonText: this.isSign ? '确认' : '签名'
      }).then(() => {
        if (!this.isSign) {
          // 未签名，打开签名弹窗
          this.$refs.mobileSignDialog.open();
        } else {
          // 已签名，提交撤回
          this.submitRevoke();
        }
      })
    },
    // 提交撤回
    submitRevoke() {
      const loading = this.$toast.loading({
        message: '处理中...',
        forbidClick: true,
        duration: 0
      });
      const withdrawSource = +this.$route.query.searchType + 1
      Api.revoke({
        caseSource: 4,
        caseOrderNo: this.caseOrderNo,
        inquireNo: withdrawSource === 2 ? this.detailInfo.inquireNo : '',
        withdrawSource
      }).then(({ data }) => {
        this.fileReviewDialog = false
        if (data.code == 0){
           Dialog.alert({
            message: '您已确认撤回申请，后续将由工作人员进行确认，您可以通过"我要查询"模块查询案件进展'
          }).then(() => {
            this.$router.back()
          });
        }
      }).finally(() => {
        loading.clear()
      })
    },
    // 签名完成回调
    signatureSubmit (event) {
      console.log('签名完成', event);
      this.fileReviewDialog = true;
      this.$nextTick(() => {
        this.writList = event.data.data.showImgPathList
      })
      this.isSign = true; // 标记已签名
    },
    openCh(data){
      console.log(data)
      this.fileReviewDialog = true
      this.loading = true
      console.log( data.data.showImgPathList)
      this.writList = data.data.showImgPathList
    },
    corrent () {
      this.$router.push({
        name: 'MNewCase',
        query: {
          number: this.number,
          opera: 1,
          name: 'DetailCase'
        }
      })
    },
    revoke () {
      if (this.searchType == 1) {
         if (this.applicantInfo.length > 1) {
        return this.$toast('涉及多申请人的案件，请线下提交撤回，如有疑问请于复议机构联系')
      }
        // this.$refs.revokeTip.open(this.searchType)
        // return
      let message = `现经沟通协商，申请人${ this.applicantInfo[0].applicantName }自愿撤回本行政复议申请，请予准许。`
      Dialog.confirm({
        title: '特别事项提醒',
        message: message,
        confirmButtonText: '申请撤回'
      })
        .then(() => {
          const withdrawSource = +this.$route.query.searchType + 1
          Api.revoke({
            inquireNo: this.inquireNo,
            caseSource: 4,
            caseOrderNo: this.caseOrderNo,
            withdrawSource
          }).then(({ data }) => {
            this.fileReviewDialog = false
            if (data.code == 0){
              Dialog.alert({
                message: '您已确认撤回申请，后续将由工作人员进行确认，您可以通过“我要查询”模块查询案件进展'
              }).then(() => {
                this.$router.back()
              });
            }
          })
        })
        .catch(() => {
          // on cancel
        });
        return;
      }
      if (this.applicantInfo.length > 1) {
        return this.$toast('涉及多申请人的案件，请线下提交撤回，如有疑问请于复议机构联系')
      }
      let message = `现经沟通协商，申请人${ this.applicantInfo[0].applicantName }自愿撤回本行政复议申请，请予准许。`
      Dialog.confirm({
        title: '特别事项提醒',
        message: message,
        confirmButtonText: '生成撤回申请书'
      })
        .then(() => {
          this.loading = true
          Api.WithdrawApplyExportWord({
            caseOrderNo: this.caseOrderNo,
            withdrawSource: +this.$route.query.searchType + 1
          }).then(({ data }) => {
            this.openCh(data)
          }).catch((err) => {
            console.error('生成撤回申请书失败:', err)
            this.loading = false
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    refreshDetail () {
      this.detail()
    },
    // 获取详情
    detail () {
      this.number = this.$route.query.number

      this.mainLoding = true

      this.fileList1 = []
      this.fileList2 = []
      const p = {
        moduleCode: moduleCodeSwitch(),
        caseOrderNo: this.number // 查询编码
      }

      if (this.searchType == 1) {
        p.searchType = 1
      }

      Api.detail(p).then(res => {
        if (res.data.code === '0') {
          const data = res.data.data
          // 处理一申请人个人信息
          if (data.applicantInfoList.length) {
            data.applicantInfoList.map(item => {
              item.genderName = item.gender == '1' ? '男' : '女'
              item.fileListJpg = []
              item.fileListJpg2 = []
              if(item.applicantCategory == '2'){
                item.identificationCard = item.contactIdentificationCard
              }
              const evidenceVoList = item.evidenceVoList || []
              evidenceVoList.forEach(img => {
                if (img.kindType == '3' || img.kindType == '0') {
                  console.log(img)
                  item.fileListJpg.push({
                    evidenceName: img.evidenceName,
                    name: img.evidenceName,
                    evidenceAllPath: img.evidenceAllPath,
                    showPath: img.evidenceAllPath,
                    evidenceType: img.evidenceType,
                    id: img.evidenceId,
                    url: img.evidencePath,
                    showPath: img.showPath,
                    showType: img.showType,
                    kindType: 3,
                    isHistory: true,
                    ...img
                  })
                } else {
                  item.fileListJpg2.push({
                    evidenceName: img.evidenceName,
                    name: img.evidenceName,
                    evidenceAllPath: img.evidenceAllPath,
                    showPath: img.evidenceAllPath,
                    evidenceType: img.evidenceType,
                    id: img.evidenceId,
                    url: img.evidencePath,
                    showPath: img.showPath,
                    showType: img.showType,
                    kindType: 4,
                    isHistory: true,
                    ...img
                  })
                }
              })
            })
          }

          let specFileList = []
          let historyList = []
          const evidence = data.evidenceList || []
          for (let i = 0; i < evidence.length; i++) {
            //type=9的附件为 行政复议申请书
            if (evidence[i].kindType === 9 || evidence[i].kindType === 7) {
              const applyBook = evidence[i]
              this.applyBook = applyBook
              historyList.push(applyBook)
              continue
            } else {
              specFileList.push(evidence[i])
            }
          }
          this.historyList = historyList
          this.specFileList = specFileList
          this.applicantInfo = data.applicantInfoList
          this.caseInfo = data.caseInfo
          this.inquireNo = data.inquireNo
          this.applyInfo = data.caseApplyDetail
          this.respondentInfo = data.respondentInfoList
          this.status = data.wssqCaseStatus

          this.hasSlsc = data.hasSlsc || ''
          const caseTips = data.caseInfo.caseTips || ''
          let modifyStatus = 0
          if (caseTips.includes('ajibzz')) {
            modifyStatus = 1
          }
          if (caseTips.includes('ajbz')) {
            modifyStatus = 2
          }
          this.modifyStatus = modifyStatus
          this.caseStatusText = data.wssqCaseStatusName
          this.caseOrderNo = data.caseInfo.caseOrderNo
          this.orgPhone = data.orgPhone
          this.detailInfo = data
        } else {
          this.$router.push('/m-caseList')
        }
      }).catch((err) => {
        console.error('获取案件详情失败:', err)
      }).finally(() => {
        this.mainLoding = false
      })
    },
    // 身份证图片下载
    downLoad (item, model) {
      const p = {
        evidenceName: item.evidenceName,
        evidenceId: item.id,
        caseOrderNo: item.caseOrderNo,
        evidencePath: item.evidencePath
      }
      console.log(p)
      Api.downloadFile(p).then((res) => {
        console.log(res)
        const fileName = decodeURI(res.headers['content-disposition'].split('=')[1])
        this.downLoadFile(fileName, res.data)
      })
    },
    // 文件下载
    downLoadFile (fileName, content) {
      const csvData = new Blob([content])
      // for IE
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(csvData, fileName)
      } else { // for Non-IE (chrome, firefox etc.)
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        const url = window.URL.createObjectURL(csvData)
        a.href = url
        a.download = fileName
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      }
    },
    // 预览
    handlePreview (item,model) {
      console.log(item, window.g.fileUrl)
      item.url =  item.originPath || item.showPath.includes('https://landing.iflysec.com:443') ? item.showPath.replace("https://landing.iflysec.com:443", "http://172.31.243.74:88") : item.showPath
      let URL = item.url
      ImagePreview({
        images: [URL],
        closeable: true,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .fileList2{
    margin-top: 60px !important;
  }

  .addr ::v-deep .van-field__control  {
    min-height:0!important;
  }

  .mobile-step {
    padding: 16px;
    display: flex!important;

    justify-content: space-between;
    align-items: center;
  }

    .pc-step {
      display: none!important;
    }

    .mobile-step .bar {
    position: absolute;
      right: -24px;
      top: 50%;
      width: 20px;
      height: 1px;
      border-top: 1px solid #4a5b9b;
      }

  .mobile-step .common {
    /* margin:10px; */
    background: #ffffff;
    border: 2px solid #468cd8;
    border-radius: 10px;
    color: #468cd8;
    padding: 3px;
    position: relative;
    max-width: 150px;
    text-align: center;
    font-size: 4vw;
  }
  .zhengjuBigbox{
    width: 100% !important;
    .zhengju {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  }

  .contry {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }



  .btnLists {
    padding: 0 16px;
    .border-btn{

  display: inline-block;
  text-align: center;
  border: 1px solid #E4E4E4;
  border-radius: 4px;
  color: #333;
  cursor: pointer;
}
  }

  .Identification {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .landline {
    margin-left: -15px;
  }

  .phoneNumber {
    margin-top: 40px;
  }

  .zxfy-titie {
    height: 60px !important;
    background-size: 180% 100% !important;
    background-position: center !important;
  }

  .main-contentBox {
    padding: 16px 0 !important;
  }

  .search-label {
    text-align: left !important;
    width: auto!important;
  }

  .appinfo-box .col1-3 {
    width: 90%
  }

  .form-common .search-label {
    width: 130px !important;
    margin-left: 0 !important;
  }

  .download-btn {
    width: 80px !important;
    position: absolute !important;
    top: 200;
    margin-top: 45px;
    margin-left: -5px !important;
  }

  .download-btn1 {
    width: 80px !important;
    position: absolute !important;
    top: 100;
    margin-left: 80px !important;
  }

  .birthday {
    margin-top: 45px;
  }

  .phone {
    margin-left: 15px;
  }

  .dp-dialog {
    width: 300px !important;

    .el-dialog {
      width: 300px !important;
    }
  }

  .el-dialog__wrapper {
    margin: auto;
  }

  .info .search-label {
    width: 120px !important;
    margin-bottom: 10px;
  }

  .reason .search-label {
    width: 120px !important;

  }

  .evidence {
    position: relative;

    //  .download-btn{
    //   position: absolute;
    //   top: -10px !important;
    //   left: 8px;
    //   }
  }

  .science .search-label {
    margin-top: 30px !important;
  }

  .fileList {

    width: 100% !important;

    .fileList-item {
      width: 90%;
      margin-bottom: 30px;

      .el-tooltip .fileList-itemText {
        line-height: 20px !important;
      }
    }

    .download-btn {
      margin-top: 30px;
      // margin-left: -20px;
      margin-left: -230px !important;
    }

    .download-btn1 {
      margin-top: 30px;
      // margin-left: -20px;
      margin-left: -50px !important;
    }

    // margin-left: -100px;

  }

  .cailiao {
    width: 100%;
    min-height: 20px !important;
    // background-color: pink;
  }

  .other {
    margin-top: -20px;
    width: 100% !important;

    .fileList-item {
      width: 90%;
      margin-bottom: 30px;
      margin-top: 10px;

      .el-tooltip .fileList-itemText {
        line-height: 20px !important;
      }
    }
  }
}

.zxfy-titie {
  background: url('~@/assets/images/zxfy-titie.png') no-repeat;
  height: 100px;
  background-size: 100% 100%;
}

.main-contentBox {
  background: linear-gradient(180deg, #FFFFFF 0%, #F5F8FE 100%);
  box-shadow: 5px 5px 20px 5px rgba(195, 195, 195, 0.09);
  padding: 20px 100px 60px;
  font-size: 14px;

  .number {
    padding: 0 16px;
    line-height: 0;
  }

  .star-title {
    width: 100%;
    margin: 0;
    padding: 10px 16px;
    background: linear-gradient(
  90deg
  , #ebe7fd 0%, #f6f5f9 100%);
  }


  .addPerson {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;

    .addPerson-btn {
      width: 81px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: rgba(90, 137, 253, 0.08);
      border-radius: 4px;
      font-size: 14px;
      border: 1px solid rgba(90, 137, 253, 0.25);
      margin-right: 15px;
    }
  }

  .mobile-step {
    display: none;
  }

  .pc-step {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pc-step .bar {
    position: absolute;
    right: -350px;
    top: 50%;
    width: 340px;
    height: 1px;
    border-top: 1px solid #4a5b9b;
  }



  .pc-step .common {
    /* margin:10px; */
    background: #ffffff;
    border: 2px solid #468cd8;
    border-radius: 10px;
    color: #468cd8;
    padding: 5px;
    position: relative;
    max-width: 150px;
    text-align: center;
    font-size: 16px;
  }



  .my-step-box .step-2 {
    border: 2px dashed #d7d7d7;
    color: #d7d7d7;
  }

  .my-step-box .step-3 {
    border: 2px dashed #d7d7d7;
    color: #d7d7d7;
  }

  .my-step-box .step-4 {
    border: 2px solid #d7d7d7;
    border-radius: 28px;
    color: #d7d7d7;
  }

  .my-step-box .active {
    border: 2px dashed #468cd8;
    border-radius: 10px;
    color: #468cd8;
  }

  .my-step-box .success {
    border-color: green;
    color: green;
  }



  .form-common {
    .appinfo-box {
      background: #fff;
      box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
      border-radius: 0px 0px 4px 4px;
      backdrop-filter: blur(20px);

      .typeTitle {
        width: 100%;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        padding:16px;

        .typeTitle-name {
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
          font-weight: bold;
          color: #333333;
          line-height: 24px;
        }
      }

      .applicat-search-items {

        .search-item {
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }

  .search {
    flex-direction: column;
    line-height: 24px;
  }

  .title-no {
    flex-direction: row;
    display: flex;

    .title-no-left {
      width: 100%;
    }

    .title-no-right {
      width: 20%;
    }

    .reback {
      border: 4px solid red;
      color: red;
      width: 90px;
      height: 90px;
      border-radius: 50%;
      font: 20px Arial, sans-serif;
      justify-content: center;
      align-items: center;
      text-align: center;
      display: flex;
    }
  }

  .fileList {
    width: 50%;
    display: flex;
    flex-direction: column;

    .fileList-item {
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: center;

      .fileList-itemText {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
      }
    }
  }

  .kong-btn {
    width: 64px;
    margin-left: 10px;
  }

  .download-btn {
    display: inline-block;
    background-color: #5A9CFF;
    height: 24px;
    width: 64px;
    line-height: 23px;
    color: white;
    border-radius: 3px;
    font-size: 12px;
    margin-left: 10px;
    text-align: center;
    cursor: pointer;
  }

  .respondentInfo-box {
    max-height: 100px;
    display: flex;
    flex-wrap: wrap;
    line-height: 26px;
    overflow: auto;
  }

  .applyInform-box {
    margin-bottom: 15px;
    line-height: 23px;
  }

  .primary-btn {
    margin-left: 10px;
  }

  .w100 {
    width: 100%;
  }

}
</style>
